/**
 * E.164 → how people write the number locally: +9647701234567 → "0770 123 4567",
 * +218912345678 → "091 234 5678". Other numbers are returned unchanged.
 */
export function formatPhone(e164: string | null | undefined): string {
  if (!e164) return '';
  const iq = /^\+964(\d{3})(\d{3})(\d{4})$/.exec(e164);
  if (iq) return `0${iq[1]} ${iq[2]} ${iq[3]}`;
  const ly = /^\+218(\d{2})(\d{3})(\d{4})$/.exec(e164);
  if (ly) return `0${ly[1]} ${ly[2]} ${ly[3]}`;
  return e164;
}
